export default "__VITE_ASSET__9f334493__"